import React, { useEffect } from 'react';
import { toast } from 'sonner';
export function PurchasePopup() {
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'San Miguel de Tucumán', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca'];
  const names = ['María', 'Laura', 'Silvina', 'Carolina', 'Andrea', 'Gabriela', 'Claudia', 'Mónica', 'Patricia', 'Alejandra', 'Valeria', 'Romina'];
  useEffect(() => {
    const showRandomPurchase = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      toast.success(`${randomName} de ${randomCity} acaba de comprar el Kit RRHH en Orden`, {
        duration: 4000,
        position: 'bottom-left'
      });
    };
    // Show first popup after 5 seconds
    const firstTimeout = setTimeout(showRandomPurchase, 5000);
    // Then show every 15-25 seconds
    const interval = setInterval(() => {
      showRandomPurchase();
    }, Math.random() * 10000 + 15000); // Random between 15-25 seconds
    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, []);
  return null;
}